import React from "react";
import "./Singlestat.css";

type Props = {
    title: string;
    value: number | string;
    testId?: string;
};

const Singlestat: React.FC<Props> = props => {
    return (
        <div className="Singlestat" data-testid={props.testId}>
            <span className="Singlestat-title">{props.title}</span>
            <span className="Singlestat-value">{props.value}</span>
        </div>
    );
};

export default Singlestat;
